var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.584,
    height: 46.5,
    viewBox: "0 0 26.584 46.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back",
    d: "M19.265,29.438,36.859,11.857a3.323,3.323,0,0,0-4.707-4.693L12.218,27.084a3.317,3.317,0,0,0-.1,4.582L32.138,51.725a3.323,3.323,0,1,0,4.707-4.693Z",
    transform: "translate(-11.251 -6.194)",
    fill: "#F95E4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowOrange);
export default __webpack_public_path__ + "static/media/leftArrowOrange.cd47f084200542fd97efe9c93ca93479.svg";
export { ForwardRef as ReactComponent };